module.exports = __webpack_public_path__ + "src/assets/img/04_atmosphere.d0f9dfca.svg";